
    import Component from 'vue-class-component';
    import RequirementSummary from "@/features/applications/components/RequirementSummary";
    import PersonalInfoDetails from "@/features/applications/components/requirements/PersonalInfoDetails.vue";

    @Component({
        components: {
                PersonalInfoDetails
        }
    })
    export default class PersonalInfoRequirementSummary extends RequirementSummary {
    }
